module.exports = __webpack_public_path__ + "img/icon_minus_gray.2038f621.svg";